import React, { useEffect, useState } from "react";
import LinkActionCard from "../../components/cards/action-card/link-action-card";
import AwardsContainer from "../../components/awards/awards-container";
import { getDataFromCmsApi } from "../../api/contentful-service";
import { parseHtml } from "../../utils/utils";
import { getColorByIndex, isExternalLink } from "../../utils/utils";
import { Box } from "@mui/material";

const InternalAudits = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const result = await getDataFromCmsApi("webpage/internalAudits");
        setData(result);
    };

    return (
        data && (
            <div>
                {/* Page Text Content */}
                <div className="container mt-5 pb-5">
                    <h1 className="display-5 text-center pb-3 text-break mt-4">{data.pageTitle}</h1>
                    <Box sx={{ marginY: 4, fontSize: { xs: "medium", sm: "large" } }}>
                        {parseHtml(data.content)}
                    </Box>
                </div>

                {/* Awards Banner */}
                <AwardsContainer pageId={"internalAuditsAwards"} doesDisplayTitle={false} />

                {/* Extra Components */}
                {data.components?.map((component, i) => (
                    <div key={i} className="container py-5 mt-4 mb-5">
                        <h2>{component.displayName}</h2>
                        <div className="grid-container grid-style-4 py-3">
                            {component?.items?.map((item, j) => (
                                <LinkActionCard
                                    key={j}
                                    title={item.serviceLabel}
                                    linkDestination={item.link}
                                    cardColor={getColorByIndex(j)}
                                    target={isExternalLink(item.link) ? "_blank" : ""}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        )
    );
};

export default InternalAudits;
